import { render, staticRenderFns } from "./RelationFieldOne.vue?vue&type=template&id=9579326e&"
import script from "./RelationFieldOne.vue?vue&type=script&lang=js&"
export * from "./RelationFieldOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RelationFieldOne.vue"
export default component.exports